import React from 'react';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import NativeHomepage from './SalesChannelEditorHomepage';
import { ChannelType, WebSiteSubType } from 'src/types/common/SalesChannel';
import { currentSelectedStyle } from 'src/constrains/SalesChannelStyleSelect/slice';
import { useSelector } from 'react-redux';
import SalesChannelEditorHomepageResponsive from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepageResponsive';

const HomepageJunction = (props) => {
  const type = useSalesChannelType();
  const isMini = type === ChannelType.MiniProgram;
  const isNative =
    useSelector(currentSelectedStyle()) === WebSiteSubType.NativeMobile;
  return isMini || isNative ? (
    <NativeHomepage {...props} />
  ) : (
    <SalesChannelEditorHomepageResponsive {...props} />
  );
};
export default HomepageJunction;
